<template>
  <div>
    <h1>Tabelas</h1>
  </div>
</template>

<script>
export default {
  name: 'Tables'
}
</script>

<style></style>
